import React from 'react';
import PropTypes from 'prop-types';

class Icon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const containerClasses = ['icon'];
    const iconClasses = ['fas', `fa-${this.props.icon}`];

    switch (this.props.size) {
      case 'large':
        containerClasses.push('is-large');
        iconClasses.push('fa-2x');
        break;
      case 'medium':
        containerClasses.push('is-medium');
        iconClasses.push('fa-lg');
        break;
      default:
        break;
    }

    return (
      <span className={`${containerClasses.join(' ')} ${this.props.className || ''}`}>
        <i className={iconClasses.join(' ')} />
      </span>
    );
  }
}

Icon.propTypes = { className: PropTypes.string, icon: PropTypes.string.isRequired, size: PropTypes.string };

export default Icon;
